import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Tabs,
  Tab,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "./../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ClassIcon from '@mui/icons-material/Class';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; 
import AssignmentIcon from '@mui/icons-material/Assignment';
import TaskAltIcon from '@mui/icons-material/TaskAlt'; 
import CancelIcon from '@mui/icons-material/Cancel'; 
import DoneIcon from '@mui/icons-material/Done';

import DataGrids from "../../utils/Datagrids";
import { GridColDef } from "@mui/x-data-grid";

type Props = {};

export default function JobManagement() {
  const [zones, setZones] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isView, setIsView] = useState(true);
  const [isView1, setIsView1] = useState(false);
  const [isView2, setIsView2] = useState(false);
  const [isView3, setIsView3] = useState(false);
  const [isView4, setIsView4] = useState(false);
  const [isView5, setIsView5] = useState(false);

  const { t } = useTranslation();
  const [value, setValue] = useState(0);

  const tabStyle = {
    default: {
      backgroundColor:`var(--header-background)`,
      color:`var(--header-color)`,
      fontWeight: "normal",
      transition: "background-color 0.3s ease, color 0.3s ease",

      "&:hover": {
        backgroundColor: "#00007a",
      },
    },
    selected: {
      backgroundColor: "#f0f0f0",
      color: "#000",
      fontWeight: "bold",

      transition: "background-color 0.3s ease, color 0.3s ease",
    },
  };

  const handleTabChange = (event: any, newValue: any) => {
    setValue(newValue);
    // Call the corresponding function based on the tab index
    switch (newValue) {
      case 0:
        handleButtonClick();
        break;
      case 1:
        AssignJobsClick();
        break;
      case 2:
        InProgressJobsClick();
        break;
      case 3:
        nextAssighmentClick();
        break;
      case 4:
        RejectedJobsClick();
        break;

      case 5:
        FinisedJobsClick();
        break;
      default:
        break;
    }
  };

  const handleButtonClick = () => {
    setValue(0);
    fetchZonesData();
    setIsView(true);
    setIsView1(false);
    setIsView2(false);
    setIsView3(false);
    setIsView4(false);
    setIsView5(false);
  };

  const AssignJobsClick = () => {
    setValue(1);
    fetchAsignData();
    setIsView1(true);
    setIsView(false);
    setIsView2(false);
    setIsView3(false);
    setIsView4(false);
    setIsView5(false);
  };

  const InProgressJobsClick = () => {
    setValue(2);
    fetchProgressData();
    setIsView2(true);
    setIsView1(false);
    setIsView(false);
    setIsView3(false);
    setIsView4(false);
    setIsView5(false);
  };

  const nextAssighmentClick = () => {
    setValue(3);
    fetchNextAsignData();
    setIsView3(true);
    setIsView1(false);
    setIsView2(false);
    setIsView(false);
    setIsView4(false);
    setIsView5(false);
  };

  const RejectedJobsClick = () => {
    setValue(4);
    fetchRejectedData();
    setIsView4(true);
    setIsView1(false);
    setIsView2(false);
    setIsView3(false);
    setIsView(false);
    setIsView5(false);
  };

  const FinisedJobsClick = () => {
    setValue(5);
    fetchfinisedData();
    setIsView5(true);
    setIsView1(false);
    setIsView2(false);
    setIsView3(false);
    setIsView4(false);
    setIsView(false);
  };


const userOptions = [
    'User 1',
    'User 2',
    'User 3',
    // Add more user options here
  ];

  const rows = [
    { id: 1, remarks: 'User 1' },
    { id: 2, remarks: 'User 2' },
    // Add more rows as needed
  ];


  

  useEffect(() => {
    fetchZonesData();
  }, []);

  const fetchZonesData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"Total Pages",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: 'remarks',
            headerName: 'User/S',
            flex: 1,
            headerClassName: 'MuiDataGrid-colCell',
            renderCell: (params) => (
              <Select
                value={params.value || ''}
                onChange={(event) => {
                  params.api.setEditCellValue({ id: params.id, field: 'remarks', value: event.target.value });
                }}
                fullWidth
              >
                {userOptions.map((user) => (
                  <MenuItem key={user} value={user}>
                    {user}
                  </MenuItem>
                ))}
              </Select>
            ),
          },

          {
            field: "email1",
            headerName:"Action",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Assign 
                </Button>
              ),
          },

         
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const fetchAsignData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"JobID",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "remarks",
            headerName:"User Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "email1",
            headerName:"Partially Assigned",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"From Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"To Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "assDate",
            headerName:"Assigned Date",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "user",
            headerName:"Status",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "action",
            headerName:"Action",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Edit
                </Button>
              ),
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const fetchProgressData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"JobID",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "remarks",
            headerName:"User Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "email1",
            headerName:"Partially Assigned",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"From Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"To Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "assDate",
            headerName:"Assigned Date",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "acptDate",
            headerName:"Accepted Date",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "user",
            headerName:"Status",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "action",
            headerName:"Action",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Edit
                </Button>
              ),
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const fetchNextAsignData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"JobID",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
         

         

          {
            field: "userid",
            headerName:"From Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"To Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

         

          {
            field: "user",
            headerName:"Status",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userName",
            headerName: "User/S",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
              <Select
                value={params.value || ""}
                onChange={(event) => {
                  params.api.setEditCellValue({
                    id: params.id,
                    field: "remarks",
                    value: event.target.value,
                  });
                }}
                fullWidth
              >
                {userOptions.map((user) => (
                  <MenuItem key={user} value={user}>
                    {user}
                  </MenuItem>
                ))}
              </Select>
            ),
          },

          {
            field: "action",
            headerName:"Action",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Asign
                </Button>
              ),
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const fetchRejectedData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"JobID",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
         
          {
            field: "userid",
            headerName:"From Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"To Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

         

         

          {
            field: "status",
            headerName:"Status",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Rollback
                </Button>
              ),
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const fetchfinisedData = async () => {
    try {
      const collectData = {
        // empid: -1,
        // userId: "-1",
        // empName: "",
        // empMobileNo: "",
        // empPincode: 0,
        // roleId: "-1",
        // empDesignationId: -1,
        // empDeptId: -1,
        // empStateId: -1,
        // empCountryID: -1,
        // empCityId: -1,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `District/GetDistrictMaster`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const zonesWithIds = data.map((emp: any, index: any) => ({
        ...emp,
        serialNo: index + 1,
        id: index + 1,
      }));

      setZones(zonesWithIds);
      setIsLoading(false);

      if (data.length > 0) {
        const columns: GridColDef[] = [
          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "firstname",
            headerName:"JobID",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "membName",
            headerName:"New Folder Name",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
         
          {
            field: "userid",
            headerName:"From Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "userid",
            headerName:"To Page",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
         

          {
            field: "status",
            headerName:"Status",
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params) => (
                <Button
                  variant="contained"
                  color="primary"
                  style={{margin:'10%'}}
                  //onClick={() => handleAssign(params.row)}
                >
                  Rollback
                </Button>
              ),
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            JOb Management
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form>
            <Grid item xs={12} container spacing={2}>
            <Grid xs={12} sm={12} item>
  <Tabs
    value={value}
    onChange={handleTabChange}
    indicatorColor="primary"
    textColor="primary"
    centered
    variant="fullWidth"
    sx={{
      minHeight: "50px",
      maxHeight: "50px",
      alignItems: "center",
    }}
  >
    <Tab
      label="Assign Job"
      icon={<ClassIcon />}
      iconPosition="start"
      sx={value === 0 ? tabStyle.selected : tabStyle.default}
    />
    <Tab
      label="Assigned Jobs"
      icon={<AssignmentIndIcon />}
      iconPosition="start"
      sx={value === 1 ? tabStyle.selected : tabStyle.default}
    />
    <Tab
      label="In Progress Jobs"
      icon={<AssignmentIcon />}
      iconPosition="start"
      sx={value === 2 ? tabStyle.selected : tabStyle.default}
    />
    <Tab
      label="Ready For Next Assignment"
      icon={<TaskAltIcon />}
      iconPosition="start"
      sx={value === 3 ? tabStyle.selected : tabStyle.default}
    />
    <Tab
      label="Rejected Jobs"
      icon={<CancelIcon />}
      iconPosition="start"
      sx={value === 4 ? tabStyle.selected : tabStyle.default}
    />
    <Tab
      label="Finished Jobs"
      icon={<DoneIcon />}
      iconPosition="start"
      sx={value === 5 ? tabStyle.selected : tabStyle.default}
    />
  </Tabs>
</Grid>

              {isView && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}

              {isView1 && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}
              {isView2 && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}

              {isView3 && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}
              {isView4 && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}

              {isView5 && (
                <>
                  <Grid xs={12} sm={12} item>
                    <DataGrids
                      isLoading={isLoading}
                      rows={zones}
                      columns={adjustedColumns}
                      pageSizeOptions={[5, 10, 25, 50, 100]}
                      initialPageSize={5}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            {/* </Card> */}
          </form>
        </CardContent>
      </div>
    </div>
  );
}
